import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-zinc-900/50 border-t border-zinc-800 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo/Brand */}
          <div className="flex items-center gap-2">
            <span className="font-heading font-bold text-lg text-white">SLAB SOCIETY</span>
            <span className="text-xs text-emerald-400 px-2 py-0.5 rounded-full bg-emerald-500/10 border border-emerald-500/20">
              0% Commission
            </span>
          </div>
          
          {/* Links */}
          <nav className="flex items-center gap-6 text-sm">
            <Link to="/marketplace" className="text-zinc-400 hover:text-white transition-colors">
              Marketplace
            </Link>
            <Link to="/about" className="text-zinc-400 hover:text-white transition-colors">
              About Us
            </Link>
            <Link to="/qa" className="text-zinc-400 hover:text-white transition-colors">
              Q&A
            </Link>
            <Link to="/legal" className="text-zinc-400 hover:text-white transition-colors">
              Legal
            </Link>
          </nav>
          
          {/* Copyright */}
          <p className="text-zinc-500 text-xs">
            &copy; {currentYear} Slab Society. All rights reserved.
          </p>
        </div>
        
        {/* Additional Links Row */}
        <div className="mt-6 pt-6 border-t border-zinc-800 flex flex-wrap items-center justify-center gap-4 text-xs text-zinc-500">
          <Link to="/legal#terms" className="hover:text-zinc-300 transition-colors">Terms of Service</Link>
          <span className="text-zinc-700">|</span>
          <Link to="/legal#privacy" className="hover:text-zinc-300 transition-colors">Privacy Policy</Link>
          <span className="text-zinc-700">|</span>
          <Link to="/rules" className="hover:text-zinc-300 transition-colors">Marketplace Rules</Link>
          <span className="text-zinc-700">|</span>
          <a href="mailto:support@slabsociety.com" className="hover:text-zinc-300 transition-colors">Contact Us</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
